export function stripZero(n) {
    if (n.slice(0, 1)?.toString() == '0' && n !=='0s') {
        return n.slice(1)
    } else {
        return n
    }
}